import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

export type UpdateUserV2Request =
  paths['/v2/users/me']['patch']['requestBody']['content']['application/json'] & {
    name?: string;
    mobilePhone?: string | null;
  };

/**
 * Update current user profile information
 *
 * Updates user data via the v2 API endpoint with profile information
 * such as name, bio, specialties, and other user attributes.
 */
export async function updateUser(body: UpdateUserV2Request) {
  const { data } = await fetchClient.PATCH('/v2/users/me', {
    body,
  });

  return data?.data;
}
